import { NotificationOffIcon, NotificationOnIcon } from "./Icons/icons";
import {
  subscribeToPush,
  unsubscribeFromPush,
} from "./ModelWindows/AddTaskModel/RequestsAPI";
import {
  ButtonNotificationToggle,
  ButtonToggleContainer,
} from "./TasksStyles.styled";

interface TaskNotificationProps {
  buttonToggle: boolean;
  swicherIcon: () => void;
}

// fix sign up display errors [done]
// fix sign in display errors [done]
// fix display task after created []

export const TaskNotification: React.FC<TaskNotificationProps> = ({
  buttonToggle,
  swicherIcon,
}) => {
  return (
    <>
      {buttonToggle ? (
        <ButtonToggleContainer>
          <ButtonNotificationToggle
            type="button"
            onClick={() => {
              swicherIcon();
              unsubscribeFromPush();
            }}
          >
            <NotificationOnIcon />
          </ButtonNotificationToggle>
        </ButtonToggleContainer>
      ) : (
        <ButtonToggleContainer>
          <ButtonNotificationToggle
            type="button"
            onClick={() => {
              swicherIcon();
              subscribeToPush();
            }}
          >
            <NotificationOffIcon />
          </ButtonNotificationToggle>
        </ButtonToggleContainer>
      )}
    </>
  );
};
